import React from 'react';
import SMFormTextField from 'components/dashboard/form/SMFormTextField';

class SMOEmbeddedCalendarView extends React.Component {

  constructor(props) {
    super(props);
    
    this.calendarColor = {
      lightGray: 'gray',
      lightDark: 'black',
    };
    
    this.state = {
      calendarColor: this.calendarColor.lightGray,
      calendarWidth: 800,
      calendarHeight: 400,
    };
  }
  
  formDidSubmit(e) {
    e.preventDefault();
    $(document).trigger("SMHideDialog");
  }
  
  linkDidClick(e) {
    e.preventDefault();
    if (e.currentTarget.name == 'close') {
      this.formDidSubmit(e);
    }
  }
  
  textFieldDidClick(e) {
    if (e.currentTarget.name == 'calendar_url') {
      e.currentTarget.select();
    }
  }
  
  textFieldDidEndEditing(e) {
    if (e.currentTarget.name == 'calendar_width') {
      this.setState({ calendarWidth: e.currentTarget.value });
    } else if (e.currentTarget.name == 'calendar_height') {
      this.setState({ calendarHeight: e.currentTarget.value });
    }
  }
  
  radioButtonDidChangeValue(e) {
    if (e.currentTarget.name == 'calendar_color') {
      this.setState({ calendarColor: e.currentTarget.value });
    }
  }
  
  render() {
    return(
       <div className="maincol-lightbox">
         <div className="form-casette maincol-lightbox__form">
           <form onSubmit={this.formDidSubmit.bind(this)}>

             <h2 className="dashboard-title mb20">
               {I18n.t('dashboard.label_000301')}
               <span className="dashboard-title__supplement mr15">
                 {I18n.t('dashboard.text_000044')}
               </span>
             </h2>
             <p className="mb10">{I18n.t('dashboard.label_000302')}</p>
             <iframe 
               src={Routes.widgets_calendar_path(
                 this.props.owner.username, 
                 this.props.roomId, 
                 { width: this.state.calendarWidth, height: this.state.calendarHeight, color: this.state.calendarColor })} 
               width={this.state.calendarWidth} 
               height={this.state.calendarHeight} 
               className="mb20">
             </iframe>
             <div className="form-box">
               <div className="w400 fl">
                 <h3 className="dashboard-title2">{I18n.t('dashboard.label_000303')}</h3>
                 <input 
                   type="radio" 
                   value={this.calendarColor.lightGray} 
                   id="form-radio01__01" 
                   name="calendar_color" 
                   checked={this.state.calendarColor == this.calendarColor.lightGray} 
                   onChange={this.radioButtonDidChangeValue.bind(this)} 
                 />
                 <label htmlFor="form-radio01__01" className="form-radio">{I18n.t('dashboard.label_000304')}</label>

                 <input 
                   type="radio" 
                   value={this.calendarColor.lightDark} 
                   id="form-radio01__02" 
                   name="calendar_color" 
                   checked={this.state.calendarColor == this.calendarColor.lightDark} 
                   onChange={this.radioButtonDidChangeValue.bind(this)} 
                 />
                 <label htmlFor="form-radio01__02" className="form-radio">{I18n.t('dashboard.label_000305')}</label>
               </div>
               <div className="w400 fl">
                 <h3 className="dashboard-title2">{I18n.t('dashboard.label_000306')}</h3>
                 <span className="mr20">{I18n.t('dashboard.label_000307')}<SMFormTextField 
                   delegate={this} 
                   name='calendar_width' 
                   value={this.state.calendarWidth} 
                   options={{className: "form-text w110 ml5 mr5"}} 
                                                                          />px</span>
                 <span className="">{I18n.t('dashboard.label_000308')}<SMFormTextField 
                   delegate={this} 
                   name='calendar_height' 
                   value={this.state.calendarHeight} 
                   options={{className: "form-text w110 ml5 mr5"}}
                                                                      />px</span>
               </div>
             </div>

             <div className="mt50">
               <h3 className="dashboard-title2 ta-c">{I18n.t('dashboard.text_000045')}</h3>
               <p className="mt10 mb30">
                 <input 
                   type="text" 
                   name='calendar_url' 
                   className="form-text w780 mr10" 
                   value={'https://reserve.spacemarket.com' + Routes.widgets_calendar_path(
                     this.props.owner.username, 
                     this.props.roomId, 
                     { width: this.state.calendarWidth, height: this.state.calendarHeight, color: this.state.calendarColor })} 
                   readOnly={true} 
                   onClick={this.textFieldDidClick.bind(this)} 
                 />
               </p>
             </div>
             <div className="ta-c mb50">
               <input className="button-gray pt10 pb10 w110 mr5" type="submit" value={I18n.t('dashboard.label_000309')} />
             </div>

             <a href="#" name="close" className="form-casette__close" onClick={this.linkDidClick.bind(this)}><i className="fa fa-times"></i></a>

           </form>
         </div>
       </div>
     );
   }
}
export default SMOEmbeddedCalendarView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/reservations/SMOEmbeddedCalendarView.jsx